import { render, staticRenderFns } from "./imgLoader.vue?vue&type=template&id=11c400ed&scoped=true&"
import script from "./imgLoader.vue?vue&type=script&lang=js&"
export * from "./imgLoader.vue?vue&type=script&lang=js&"
import style0 from "./imgLoader.vue?vue&type=style&index=0&id=11c400ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c400ed",
  null
  
)

export default component.exports